module.exports = __webpack_public_path__ + "img/illustration-step-3-01.4db70edd.svg";